"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
/**
 * Interval function
 * @param callback function to execute after delay
 * @param delay delay in executing effect
 */
var useInterval = function (callback, delay) {
    react_1["default"].useEffect(function () {
        if (delay !== null) {
            var id_1 = setInterval(callback, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [callback, delay]);
};
exports["default"] = useInterval;
